import request from '@/utils/request'
import { INTERFACE_SPLITS } from '@/constants/module/interface'

export function getOrgs(query) {
  return request({
    url: '/admin/v1/orgs',
    method: 'get',
    params: query
  })
}
// 用于选择用户的模糊搜索、用户管理-查询列表
export function getUser(query) {
  const { limit = 0 } = query
  if (limit >= 5000) {
    return new Promise((resolve, reject) => reject())
  }
  return request({
    url: '/admin/v1/users',
    method: 'get',
    params: query
  })
}

export function addUser(data) {
  return request({
    url: '/admin/v1/users',
    method: 'post',
    data
  })
}

/**
 * @description: 获取扶摇用户详情
 * @param {*} id 扶摇用户id
 * @param {*} type 查看、编辑接口进行拆分，目的是对信息进行脱敏操作 枚举值为view、edit
 * @return {*}
 */
export function detailUser(id, type = 'view') {
  if (type === 'view') {
    return request({
      url: `${INTERFACE_SPLITS.USER_DETAIL[type]}/${id}`,
      method: 'get'
    })
  } else {
    return request({
      url: `${INTERFACE_SPLITS.USER_DETAIL[type]}`,
      method: 'get',
      params: { user_id: id }
    })
  }
}

export function updateUser(obj) {
  return request({
    url: `/admin/v1/users/${obj.id}`,
    method: 'put',
    data: obj.temp
  })
}

export function getSelectRole(id) {
  return request({
    url: `/admin/v1/users/${id}/roles`,
    method: 'get'
  })
}

export function setRole(obj) {
  return request({
    url: `/admin/v1/users/${obj.id}/roles`,
    method: 'put',
    data: obj.data
  })
}

export function setStatus(id, status) {
  return request({
    url: `/admin/v1/users/${id}/status/${status}`,
    method: 'patch'
  })
}

export function getCityRuleSaveOrUpdate(data) {
  return request({
    url: `/admin/v1/thirdTransport/cityRule/saveOrUpdate`,
    method: 'post',
    data
  })
}

export function getCityRuleInfo(query) {
  return request({
    url: `/admin/v1/thirdTransport/cityRule/info`,
    method: 'get',
    params: query
  })
}
// 车辆信息模板导出
export function thirdTransportCarInfoExport(data){
  return request({
    url: `/admin/v1/thirdTransport/car/info_export`,
    method: 'POST',
    data
  })
}
// 司机信息模板导出
export function thirdTransportDriverInfoExport(data){
  return request({
    url: `/admin/v1/thirdTransport/driver/info_export`,
    method: 'POST',
    data
  })
}
export function getUserLog(query) {
  return request({
    url: `/admin/v1/operation_log/list`,
    method: 'get',
    params: query
  })
}
/**
 * 删除用户
 * @param { number } params.id 用户id
 * @returns
 */
export function deleteUser(params) {
  return request({
    url: `/admin/v1/users/delete`,
    method: 'post',
    data: params
  })
}
